import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.css','./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {
  title="Create Lead";
  constructor() { }
  storedTheme: string;
  ngOnInit() {
    this.storedTheme = localStorage.getItem('theme-color');
  }
  setTheme(theme) {
    localStorage.setItem('theme-color', theme);
    this.storedTheme = localStorage.getItem('theme-color');
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/Lead/lead-form/lead-form.component.ts